import { FC } from 'react';
import CopyTextButton from 'v3/common/components/CopyTextButton';
import PortalToTarget from 'v3/common/components/PortalToTarget';

const oneIndentation = ' ';

const Fivepaisa: FC = () => (
  <div id="stepper__container">
    <PortalToTarget targetClassName="login-modal__header" allowForWeb>
      <h3>Fivepaisa API Setup in 6 Steps</h3>
    </PortalToTarget>

    <div className="stepper">
      <li className="stepper_item" data-stepper="1">
        <div className="stepper_content">
          <p>
            Visit the <b>5paisa website</b> and complete the <b>login</b> procedures.
          </p>
          <button className="stepper-btn">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path
                d="M15 3H21V9"
                stroke="#1F252C"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M10 14L21 3"
                stroke="#1F252C"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M18 13V19C18 19.5304 17.7893 20.0391 17.4142 20.4142C17.0391 20.7893 16.5304 21 16 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V8C3 7.46957 3.21071 6.96086 3.58579 6.58579C3.96086 6.21071 4.46957 6 5 6H11"
                stroke="#1F252C"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <a href="https://xstream.5paisa.com/dashboard" target="blank" rel="noreferrer">
              Open Dashboard{' '}
            </a>
          </button>
        </div>
        <img
          src="/images/broker_setup_guide/fivepaisa/step_1.png"
          className="w-100 mt-3"
          alt="Fivepaisa login page"
        />
      </li>
      <li className="stepper_item" data-stepper="2">
        <div className="stepper_content">
          <p>
            Then, select the <b>Create New App</b> option.
          </p>
          <img
            src="/images/broker_setup_guide/fivepaisa/step_2.png"
            className="w-100"
            alt="Fivepaisa Create New App"
          />
        </div>
      </li>
      <li className="stepper_item" data-stepper="3">
        <div className="stepper_content">
          <p>
            Next, <b>fill in</b> the required details.
          </p>
          <img src="/images/broker_setup_guide/fivepaisa/step_3.png" alt="Fivepaisa Email verification" />
          <div className="stepper__form">
            <div className="stepper__form-group">
              <h6>App Name:</h6>
              <div className="stepper__input-group">
                <span>
                  {oneIndentation}
                  <input type="text" placeholder="Quantman" disabled />
                </span>
                <CopyTextButton text="Quantman" />
              </div>
            </div>
            <div className="stepper__form-group">
              <h6>Redirect Url: </h6>
              <div className="stepper__input-group">
                <span>
                  {oneIndentation}
                  <input type="text" placeholder="https://quantman.trade/auth/fivepaisa/callback" disabled />
                </span>
                <CopyTextButton text="https://quantman.trade/auth/fivepaisa/callback" />
              </div>
            </div>
            <div className="stepper__form-group">
              <h6>Static IP: </h6>
              <div className="stepper__input-group">
                <span>
                  {oneIndentation}
                  <input type="text" placeholder="Contact QuantMan Support" disabled />
                </span>
                <CopyTextButton text="" disabled />
              </div>
            </div>
            {/* <div className="stepper__form-group">
              <h6>Algo ID: </h6>
              <div className="stepper__input-group">
                <span>
                  {oneIndentation}
                  <input type="text" placeholder="0" disabled />
                </span>
                <CopyTextButton text="0" />
              </div>
            </div> */}
          </div>
        </div>
      </li>
      <li className="stepper_item" data-stepper="4">
        <div className="stepper_content">
          <p>
            Now, click the <b>Submit</b> button, and an <b>API Key</b> with an <b>Encryption Key</b> and
            {oneIndentation}
            <b>User ID</b> will be successfully created.
          </p>
        </div>
      </li>
      <li className="stepper_item" data-stepper="5">
        <div className="stepper_content">
          <p>
            Once the Submit was done. click the card it will list the <b>API Key</b>, <b>Encryption Key</b>{' '}
            and
            {oneIndentation}
            <b>User ID</b>.
          </p>
          <img
            src="/images/broker_setup_guide/fivepaisa/step_4.png"
            className="w-100"
            alt="Fivepaisa Create new application"
          />
        </div>
      </li>
      <li className="stepper_item" data-stepper="5">
        <div className="stepper_content">
          <p>
            Then click the modify button it enable to configure static ip. If you don{"'"}t have static ip
            contact
            {oneIndentation}
            <b>QuantMan Support</b>.
          </p>
          <img
            src="/images/broker_setup_guide/fivepaisa/step_5.png"
            className="w-100"
            alt="Fivepaisa Create new application"
          />
        </div>
      </li>
      <li className="stepper_item" data-stepper="6">
        <div className="stepper_content">
          <p>
            Put the ip address in the static ip field and click the <b>Submit</b> button.
          </p>
          <img src="/images/broker_setup_guide/fivepaisa/step_6.png" className="w-100" alt="Broker " />
        </div>
      </li>
      <li className="stepper_item" data-stepper="6">
        <div className="stepper_content">
          <p>
            Once the submit was done. successfully application created and <b>IP </b>added
          </p>
        </div>
      </li>
    </div>
  </div>
);

export default Fivepaisa;
